export default __webpack_public_path__ + "static/media/ArrowRight.1caf88e2.svg";